import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from './Icons';
export function FailedApproaches() {
  return <section className="w-full bg-white-soft py-10 md:py-24 px-5" data-id="element-155">
      <div className="max-w-2xl mx-auto" data-id="element-156">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-2xl md:text-3xl font-bold text-brown-dark text-center mb-7 md:mb-12" data-id="element-157">
          ¿Por qué lo que has probado no ha funcionado?
        </motion.h2>

        <div className="space-y-6" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex gap-4" data-id="element-159">
            <div className="flex-shrink-0 mt-1" data-id="element-160">
              <XCircleIcon className="w-6 h-6 text-brown-light" data-id="element-161" />
            </div>
            <div data-id="element-162">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-163">
                Champús "anticaída" de farmacia
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-164">
                Son demasiado alcalinos y destruyen la barrera protectora de tu
                piel.
              </p>
            </div>
          </motion.div>

          <div className="ml-10 border-t border-gold/15" data-id="element-165" />

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex gap-4" data-id="element-166">
            <div className="flex-shrink-0 mt-1" data-id="element-167">
              <XCircleIcon className="w-6 h-6 text-brown-light" data-id="element-168" />
            </div>
            <div data-id="element-169">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-170">
                Vitaminas genéricas
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-171">
                Nunca llegan a la raíz porque tu sistema digestivo prioriza
                otros órganos antes que el cabello.
              </p>
            </div>
          </motion.div>

          <div className="ml-10 border-t border-gold/15" data-id="element-172" />

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex gap-4" data-id="element-173">
            <div className="flex-shrink-0 mt-1" data-id="element-174">
              <XCircleIcon className="w-6 h-6 text-brown-light" data-id="element-175" />
            </div>
            <div data-id="element-176">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-177">
                Aceites pesados y tónicos con alcohol
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-178">
                Obstruyen los poros inflamados, atrapando el calor y empeorando
                la caída.
              </p>
            </div>
          </motion.div>

          <div className="ml-10 border-t border-gold/15" data-id="element-179" />

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex gap-4" data-id="element-180">
            <div className="flex-shrink-0 mt-1" data-id="element-181">
              <XCircleIcon className="w-6 h-6 text-brown-light" data-id="element-182" />
            </div>
            <div data-id="element-183">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-184">
                Masajes bruscos
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-185">
                Arrancan el cabello que está en fase de reposo, acelerando la
                calvicie visible.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}